import { createSelector } from "reselect";

import type { ResultsReduxState } from "@app/types/results-redux-types";
import type { SearchDepartureType, SearchInfo } from "@app/types/search-types";

import { isReturn, isRoundtrip } from "../../../helpers/search";

export const getSearch = (state: ResultsReduxState) => state.search;

export const createGetDirectionFromSearch = () =>
  createSelector([getSearch], (search: SearchInfo): SearchDepartureType => {
    if (isReturn(search)) {
      return "return";
    } else {
      return isRoundtrip(search) ? "outbound" : "one-way";
    }
  });

/**
 * Return total number of each passenger type
 */
export const getPassengerDetailedCount = createSelector([getSearch], search => {
  return { adult: search.adult, child: search.child, senior: search.senior };
});
